module.exports = __webpack_public_path__ + "comb.jpg?739dad4e2644799a96dbfef405bce637";